__turbopack_context__.v({
  "badge": "chip-module-scss-module__iF3Eqa__badge",
  "error": "chip-module-scss-module__iF3Eqa__error",
  "warning": "chip-module-scss-module__iF3Eqa__warning",
});
